import React from 'react';
import PropTypes from 'prop-types';
import { connect } from 'react-redux';
import { Link } from 'react-router-dom';
import Helmet from 'react-helmet';
import _ from 'lodash';

import { generateKey } from '../../utils';
import Placeholder from '../Placeholder';
import { Wrapper, Container, Item, NameWrapper, Arrow, Spacer } from './BreadCrumbMenus.style';

// 配列の長さを比較するのに使用する
const COEFFICIENT = 1;

/**
 * パンくずリスト表示用コンポーネント
 */
const BreadCrumbMenus = ({ currentPath, items, product, intl, gray }) => {
  // position パラメータ設定用係数
  const coefficientAddition = 1;
  const itemList =
    items.length > 0
      ? items.map(({ name, path }, index) => {
          let id;
          if (index + COEFFICIENT === items.length) {
            id = currentPath;
          } else {
            id = path ? `https://www.shiseido-professional.com${path}` : '';
          }
          return JSON.stringify({
            '@type': 'ListItem',
            position: index + coefficientAddition,
            item: {
              '@id': id,
              name,
            },
          });
        })
      : null;
  const productImages =
    product && _.get(product, 'variants')
      ? product.variants.map(({ image }) => !!_.get(image, 'file.url') && JSON.stringify(image.file.url))
      : null;
  return (
    <Wrapper gray={gray}>
      <Helmet>
        <script type="application/ld+json">
          {`
            [{
              "@context": "http://schema.org",
              "@type": "BreadcrumbList",
              "itemListElement": [${itemList}]
            }]
          `}
        </script>
        {/* TODO: mpn パラメータに商品番号が動的に入るようにする。(contentful にデータがないので、現在 (2019年11月27日) 確認中) */}
        {/* {!!(
          product &&
          _.get(product, 'name') &&
          _.get(product, 'description') &&
          _.get(product, 'variants') &&
          _.get(intl, 'messages.currency')
        ) && (
          <script type="application/ld+json">
            {`
              [{
                "@context": "http://schema.org",
                "@type": "Product",
                "offers": {
                  "@type": "AggregateOffer",
                  "lowPrice": ${_.get(product.variants[0], 'price') || null},
                  "priceCurrency": "${intl.messages.currency}"
                },
                "name": "${product.name}",
                "image": [${productImages}],
                "description": "${product.description}",
                "mpn": "1",
                "brand": {
                  "@type": "Thing",
                  "name": "Shiseido Professional"
                }
              }]
            `}
          </script>
        )} */}
      </Helmet>
      <Container>
        {!items ? (
          <Placeholder w="200px" h="24px" />
        ) : (
          <React.Fragment>
            {items.map(({ name, path }, index) => (
              <Item key={generateKey('bread-crumb-menu', index)}>
                <NameWrapper className={path ? 'withLink' : null}>
                  {path ? (
                    path.indexOf('/salon-locator') >= 0 ||
                    path.indexOf('/beauty-consultation') >= 0 ||
                    path.indexOf('/salon-consultation/') >= 0 ? (
                      <Link to={path} href={path}>
                        {name}
                      </Link>
                    ) : (
                      <a href={`https://www.shiseido-professional.com${path}`}>{name}</a>
                    )
                  ) : (
                    <React.Fragment>{name}</React.Fragment>
                  )}
                </NameWrapper>
                <Spacer />
                {!!(index + COEFFICIENT < items.length) && (
                  <React.Fragment>
                    <Arrow>&gt;</Arrow>
                    <Spacer />
                  </React.Fragment>
                )}
              </Item>
            ))}
          </React.Fragment>
        )}
      </Container>
    </Wrapper>
  );
};

BreadCrumbMenus.defaultProps = {
  product: {},
  gray: false,
};

BreadCrumbMenus.propTypes = {
  // 通貨コード
  intl: PropTypes.shape({}).isRequired,
  // パンくずリストの現在地のパス
  currentPath: PropTypes.string.isRequired,
  // パンくずリストの構造化データマークアップに使用する
  items: PropTypes.arrayOf(PropTypes.shape()).isRequired,
  // 商品情報の構造化データマークアップに使用する
  product: PropTypes.shape({}),
  gray: PropTypes.bool,
};

const mapState = state => ({
  // 通貨コードをキャッシュしておく
  intl: state.intl,
});

export default connect(mapState)(BreadCrumbMenus);



// WEBPACK FOOTER //
// ./src/components/BreadCrumbMenus/index.js